$(document).ready(function(){
  
  var box_content_variants = new Array();
  
  $('.box_content').hide();
  
   	// step-1 jquery
    
      $('.packaging-option').click(function(e){
        e.preventDefault();
        
        var var_id = $(this).attr('data-variant-id');
        
        var var_color = $(this).attr('data-variant-name');

        $('.packaging-option').removeClass("selected");
        $('.pick-color').show();
        $("#"+var_id).addClass("selected");
        $('.step-2').addClass('active');
        $('.packaging-wrapper').hide();
        $('.custom-gift-collection').show();
        $('.filter-box').show();
        $('.pick-color',this).hide();
        $('.box-color').text(var_color);
        
        $('html,body').animate({ 'scrollTop': $('#progressbar').offset().top - 200 });
        
                         
          var box_id = $(this).attr('data-variant-id');
          
          var box_title = $(this).attr('data-variant-name');
          
          var box_image = $(this).attr('data-variant-image');

          var bx_price = $(this).attr('data-variant-price');

          
          var box_tray_subtotal = $('.tray-subtotal').text();
          
         var box_t_subtotal = box_tray_subtotal.replace(/[^\d.]/g, '');


         box_t_subtotal  = parseFloat(box_t_subtotal);

           var box_p_price  = parseFloat(bx_price);
         
         	box_p_price = box_p_price / 100;

          var box_t_total = box_t_subtotal + box_p_price;

          box_t_total = parseFloat(box_t_total).toFixed(2);
        
          var r_bx_price = $('.tary-items-list .box').attr('data-price');
          
          r_bx_price = parseFloat(r_bx_price).toFixed(2);
        
          if(r_bx_price != 'NaN')          
          {
              box_t_total =  box_t_total - r_bx_price;
              box_t_total = parseFloat(box_t_total).toFixed(2);

          }


          $('.tary-items-list .box').remove();


          var box_qty = $(".tary-items-list ."+box_id).length;
         
          box_qty = box_qty + 1;

        $(".tary-items-list").append('<li class="tray-item box '+box_id+'" id="item-'+box_id+'-'+box_qty+'" data-variant="'+box_id+'" data-type="box" data-price="'+box_p_price+'"><span class="qty-count"></span><span class="item-delete-btn" data-item="box" btn_id="' + box_id + '">X</span><img class="item-image" src="'+box_image+'"><span class="item-title">'+box_title+'</span><span class="item-price">$'+box_p_price+'</li>');

        $('#qty-'+box_id).show();
        $('#quick-view-'+box_id).hide();
        $('#prod-'+box_id+' .about-btn').hide();
        $('#grid-'+box_id).addClass('enable-qty');

                
          box_p_price = box_p_price * box_qty;

          box_p_price  = parseFloat(box_p_price).toFixed(2);

           
          $(".custom-tray-wrapper").css('display','block');

          $('.tray-subtotal').text(box_t_total);

          $('#qty-'+box_id+' .qty-text').text(box_qty);

          $('.'+box_id+' .qty-count').text(box_qty);

          $('.'+box_id+' .item-price').text('$'+box_p_price);
        
              
        tray_slider();
	
    });
  
  
  
  	
  
  	// Progress Bar
  
      $('.step-1').click(function(){
        
          if($(this).hasClass('active'))
          {
			    
        	$('#step1').show();
        	$('.page-width--flush-small #step2').hide();
        	$('#step3').hide();
            $('.shipping-section').hide();
            $('.filter-box').hide();
          }
      });
  
  
  	  $('.step-2').click(function(){
        
          if($(this).hasClass('active'))
          {

			$('#step1').hide();
        	$('.page-width--flush-small #step2').show();
			$('#step3').hide();
            $('.shipping-section').hide();
            $('.filter-box').show();
          }
      });
  
  
  	 $('.step-3').click(function(){
       
       	  if($(this).hasClass('active'))
          {

			$('#step1').hide();
        	$('.page-width--flush-small #step2').hide();
			$('#step3').show();
            $('.shipping-section').hide();
            $('.filter-box').hide();
          }
     });
  
  
 
  
  
  	$(document).on("click", ".quick-view-button", function () {
      
        var prod_title = $(this).attr('data-title');

        var prod_image = $(this).attr('data-image');
      
        var prod_price = $(this).attr('data-price');

        var prod_id = $(this).attr('data-id');
      
        var prod_variant_id = $(this).attr('data-variant-id');

        var tray_subtotal = $('.tray-subtotal').text();
      
      	var tray_total_items = $('.tray-total-items').text();
      
      	tray_total_items = parseInt(tray_total_items);

        var t_subtotal = tray_subtotal.replace(/[^\d.]/g, '');

        var p_price = prod_price.replace(/[^\d.]/g, '');

        t_subtotal  = parseFloat(t_subtotal);

        p_price  = parseFloat(p_price);
      
      	p_price = p_price / 100;

        var t_total = t_subtotal + p_price;

        t_total = parseFloat(t_total).toFixed(2);

        p_price = p_price.toFixed(2);

        var qty = $(".tary-items-list ."+prod_id).length;

        if(qty < 1)
        {

          qty = qty + 1;

          
          $(".tary-items-list").append('<li class="tray-item '+prod_id+'" id="item-'+prod_id+'-'+qty+'" data-variant="'+prod_variant_id+'" data-type="box_content"><span class="qty-count"></span><span class="item-delete-btn" btn_id="' + prod_id + '">X</span><img class="item-image" src="'+prod_image+'"><span class="item-title">'+prod_title+'</span><span class="item-price">$'+prod_price+'</li>');

        }
        else
        {
          qty = qty + 1;

          $(".tary-items-list").append('<li class="tray-item '+prod_id+'" id="item-'+prod_id+'-'+qty+'" data-variant="'+prod_variant_id+'" style="display:none" type="box_content"><span class="qty-count"></span><span class="item-delete-btn" btn_id="' + prod_id + '">X</span><img class="item-image" src="'+prod_image+'"><span class="item-title">'+prod_title+'</span><span class="item-price">$'+prod_price+'</li>');

          p_price = p_price * qty;

          p_price  = parseFloat(p_price).toFixed(2);

        }
      
      
      	 tray_total_items = tray_total_items + qty;
      
      	 $('#qty-'+prod_id).show();
          $('#quick-view-'+prod_id).hide();
          $('#prod-'+prod_id+' .about-btn').hide();
          $('#grid-'+prod_id).addClass('enable-qty');
      
        $(".custom-tray-wrapper").css('display','block');

        $('.tray-subtotal').text(t_total);

        $('#qty-'+prod_id+' .qty-text').text(qty);
      
      	$('#about-qty-'+prod_id+' .about-qty-text').text(qty);

        $('.'+prod_id+' .qty-count').text(qty);
      
      	 $('.tray-total-items').text(tray_total_items);

        $('.'+prod_id+' .item-price').text('$'+p_price);
  
    
   });
  
  
  		// Quantity box 
  
  
  		// Plus Button
  
       $(document).on("click", ".qty-plus-btn", function () {
          
          
          var pd_id = $(this).attr('data-id');
          
          var pd_title = $('.prod-data-'+pd_id).attr('prod-data-title');
          
          var pd_image = $('.prod-data-'+pd_id).attr('prod-data-image');

          var pd_price = $('.prod-data-'+pd_id).attr('prod-data-price');
         
          var pd_variant_id = $('.prod-data-'+pd_id).attr('prod-data-variant-id');
         
         
         var tray_total_items = $('.tray-total-items').text();
      
      	tray_total_items = parseInt(tray_total_items);

          
          var pd_tray_subtotal = $('.tray-subtotal').text();
          
         var pd_t_subtotal = pd_tray_subtotal.replace(/[^\d.]/g, '');


         pd_t_subtotal  = parseFloat(pd_t_subtotal);

           var pd_p_price  = parseFloat(pd_price);
         
         	pd_p_price = pd_p_price / 100;

          var pd_t_total = pd_t_subtotal + pd_p_price;

          pd_t_total = parseFloat(pd_t_total).toFixed(2);


          var pd_qty = $(".tary-items-list ."+pd_id).length;
         
         if(pd_qty < 1)
          {
			    pd_qty = pd_qty + 1;

                $(".tary-items-list").append('<li class="tray-item '+pd_id+'" id="item-'+pd_id+'-'+pd_qty+'" data-variant="'+pd_variant_id+'" data-type="box_content"><span class="qty-count" ></span><span class="item-delete-btn" btn_id="' + pd_id + '">X</span><img class="item-image" src="'+pd_image+'"><span class="item-title">'+pd_title+'</span><span class="item-price">$'+pd_p_price+'</li>');

                 $('#qty-'+pd_id).show();
                 $('#quick-view-'+pd_id).hide();
                $('#prod-'+pd_id+' .about-btn').hide();
                $('#grid-'+pd_id).addClass('enable-qty');

          }
         else{
                  
         pd_qty = pd_qty + 1;
                    
          $(".tary-items-list").append('<li class="tray-item '+pd_id+'" id="item-'+pd_id+'-'+pd_qty+'" data-variant="'+pd_variant_id+'" style="display:none" data-type="box_content"><span class="qty-count"></span><span class="item-delete-btn" btn_id="' + pd_id + '">X</span><img class="item-image" src="'+pd_image+'"><span class="item-title">'+pd_title+'</span><span class="item-price">$'+pd_p_price+'</li>');

          $('#qty-'+pd_id).show();
          $('#quick-view-'+pd_id).hide();
          $('#prod-'+pd_id+' .about-btn').hide();

          $('#grid-'+pd_id).addClass('enable-qty');
           
         }
         
         
          pd_p_price = pd_p_price * pd_qty;

          pd_p_price  = parseFloat(pd_p_price).toFixed(2);
         
         
          tray_total_items = tray_total_items + 1;

           
          $(".custom-tray-wrapper").css('display','block');

          $('.tray-subtotal').text(pd_t_total);

          $('#qty-'+pd_id+' .qty-text').text(pd_qty);
         
          $('#about-qty-'+pd_id+' .about-qty-text').text(pd_qty);

          $('.'+pd_id+' .qty-count').text(pd_qty);
         
         $('.tray-total-items').text(tray_total_items);

          $('.'+pd_id+' .item-price').text('$'+pd_p_price);
         
         
         	tray_slider();
         
	
          
        });
  
  
  	// Minus Button
  
  
  
  		$(document).on("click", ".qty-minus-btn", function (){
          
                 
          var pd_btn_id = $(this).attr('data-id');
    
    	  var pd_item_tray_total = $('.tray-subtotal').text();
    
    	  var item_price = $('.prod-data-'+pd_btn_id).attr('prod-data-price');
          
          var tray_total_items = $('.tray-total-items').text();
      
      	tray_total_items = parseInt(tray_total_items);
    
             			 
          pd_item_tray_total = pd_item_tray_total.replace(/[^\d.]/g, '');
          
          pd_item_tray_total = parseFloat(pd_item_tray_total);
  
  		  item_price =parseFloat(item_price);
    
    	 item_price = item_price / 100;
  
  		  var new_subtotal = pd_item_tray_total - item_price;
  
  		  new_subtotal = parseFloat(new_subtotal).toFixed(2);
  
  		      
    	 var item_qty = $(".tary-items-list ."+pd_btn_id).length;
    
          if(item_qty <= 1)
          {
          
          		$('.'+pd_btn_id).remove();
            
            	tray_total_items = tray_total_items - 1;
             $('.tray-total-items').text(tray_total_items);
            
            	 $('#qty-'+pd_btn_id).hide();
    			$('#quick-view-'+pd_btn_id).show();
    			$('#prod-'+pd_btn_id+' .about-btn').show();
  				$('#grid-'+pd_btn_id).removeClass('enable-qty');
            
           
          }
    		else
    		{
				$('#item-'+pd_btn_id+'-'+item_qty).remove();
              
              	item_qty = item_qty - 1;
              
              	item_price = item_price * item_qty;
              
              	item_price  = parseFloat(item_price).toFixed(2);
              
              	tray_total_items = tray_total_items - 1;
              
              	$('#qty-'+pd_btn_id+' .qty-text').text(item_qty);
              
              	$('#about-qty-'+pd_btn_id+' .about-qty-text').text(item_qty);

          		$('.'+pd_btn_id+' .qty-count').text(item_qty);
              	
              	 $('.tray-total-items').text(tray_total_items);

          		$('.'+pd_btn_id+' .item-price').text('$'+item_price);
              
              	$('#qty-'+pd_btn_id).show();
          		$('#quick-view-'+pd_btn_id).hide();
          		$('#prod-'+pd_btn_id+' .about-btn').hide();

          		$('#grid-'+pd_btn_id).addClass('enable-qty');

    		}
  
  		  	$(".custom-tray-wrapper").css('display','block');

          	$('.tray-subtotal').text(new_subtotal);
		
  			tray_slider();
       });
  
  
  	$(document).on("click", ".item-delete-btn", function (){
          
                 
          var btn_id = $(this).attr('btn_id');
  
  		  var data_item = $(this).attr('data-item');
  
          var item_tray_total = $('.tray-subtotal').text();
  
  		  var qty = $(".tary-items-list ."+btn_id).length;
     			          
          var item_price = $('#item-'+btn_id+'-'+qty+' .item-price').text();
      			 
          item_tray_total = item_tray_total.replace(/[^\d.]/g, '');
          
          item_price = item_price.replace(/[^\d.]/g, '');
  
   		  item_tray_total = parseFloat(item_tray_total);
  
  		  item_price =parseFloat(item_price);
  
  			var tray_total_items = $('.tray-total-items').text();
      
      		tray_total_items = parseInt(tray_total_items);
  
  			tray_total_items = tray_total_items - qty;
  
  			$('.tray-total-items').text(tray_total_items);
  
  		  var new_subtotal = item_tray_total - item_price;
  
  		  new_subtotal = parseFloat(new_subtotal).toFixed(2);
  
  		  $('.tray-subtotal').text(new_subtotal);
  
  			  
  		  $('.'+btn_id).remove(); 	
  
  		  $('#qty-'+btn_id).hide();
    	$('#quick-view-'+btn_id).show();
    	$('#prod-'+btn_id+' .about-btn').show();
  		$('#grid-'+btn_id).removeClass('enable-qty');
  
  
  		if(data_item == 'box')
        {
        
        	$('#step1').show();
        	$('.page-width--flush-small #step2').hide();
           $('.filter-box').hide();
        	$('#step3').hide();
                   
          	$('.step-2').removeClass('active');
          	$('.step-3').removeClass('active');
          
          	$("#"+btn_id).addClass("selected");
          
          	$('#'+btn_id).removeClass('selected');
          
          	$('.pick-color').show();
          
          	$('.tray-item').remove();
          
          	 $('.tray-subtotal').text('0.00');
          
          	$(".custom-tray-wrapper").css('display','none');
          
          	$('html,body').animate({ 'scrollTop': $('#progressbar').offset().top - 200 });
                
        }
  
  
   
  });
  
  
  
  
  
  		// Step-3 
  
  		// Tray complete button
  
  		$('.tray-complete-btn').click(function(){
          
          	var tray_items = $('.tray-total-items').text();
          
          	var box_min_qty = $('.message-box').attr('data-min');
                
            var box_max_qty = $('.message-box').attr('data-max');
          
          	if(tray_items < box_min_qty)
            {
              
              $('.message-box').text('Your box must have at least '+box_min_qty+' items.');
              
            }
          	else if(tray_items > box_max_qty)
            
            {
            	 $('.message-box').text('Box contains maximum '+box_max_qty+' items.');
            
            }
            else
            {

              var box_content = new Array();
              
              var tray_total_price = $('.tray-subtotal').text();

              $('.tary-items-list li:not(:first-child):visible').each(function() {
                
                 var final_item_desc = '';

                 var t_item_qty = $('.qty-count',this).text();

                 var t_item_title = $('.item-title',this).text();
                
                  var variant_id = $(this).attr('data-variant');

                 final_item_desc = t_item_qty+'X '+t_item_title;

                 box_content.push(final_item_desc);
                
                
                var data_type = $(this).attr('data-type');
                
                var variant_id = $(this).attr('data-variant');
                
                var item={};
                
                var random_p_id = Math.floor(Math.random() * (5000 - 1) + 1);
                      
           
                if(data_type == 'box_content')

                {

                  item ["quantity"] = t_item_qty;
                  item ["id"] = variant_id;
                  item ["properties"] = {

                    "type": data_type,
                    "box_content":"true",
                    "p_id":random_p_id
                   
                  } 


                }
                
                box_content_variants.push(item);
                                
                                 
                });
                                        
         
              $('.box_content').text(box_content);

              $('.box_content').attr('data-price',tray_total_price);


              $('.packaging-wrapper').hide();
              $('.custom-gift-collection').hide();
              $('.filter-box').hide();
              $('.card-section').show();

              $('.step-3').addClass('active');

              $(".custom-tray-wrapper").css('display','none');

              $('html,body').animate({ 'scrollTop': $('#progressbar').offset().top - 200 });

            }
            
        });
  
  
  		// Select specific card
  
  
  		$('.card-text').click(function(){
          
          
          var card_image = $(this).attr('card-data-image');
          
          var card_name = $(this).attr('card-data-name');
          
          $('.card-detail-image').attr('src',card_image);
          
          $('.card-name').text(card_name);
          
          $('.card-section-list').hide();
          
          $('.card-section-detail').show();
          
          $('html,body').animate({ 'scrollTop': $('#progressbar').offset().top - 200 });
               
        
        });
  
  
  		// Card form message character count
  
  
  		 $("#card-message").on('keyup', function(){ 

            var Characters = $("#card-message").val().replace(/(<([^>]+)>)/ig,"").length; 
           
           var bal_char = 120 - Characters;
           
           $("#counter").text(bal_char);
           
  		});
  
  		
  		// Card change button on card form
  
  
  
        $('.card-change-btn').click(function(){

			$('.card-section-list').show();
          
          	$('.card-section-detail').hide();
          
          	$('#to').val('');
          
          	$('#from').val('');
          
          	$('#card-message').val('');
          
            $('#type').prop("checked", false);
          
          	$('html,body').animate({ 'scrollTop': $('#progressbar').offset().top - 200 });

        });
  
  

  
  
  		$(document).ready(function(){

			check_field_value();
		

      	});
  
  
        $(document).on("change", "#type", function (){

          check_field_value();


        });
  
   

  
  		 $(document).on("keyup", ".card_field", function (){
           
                  check_field_value();
         
        
        });
  
  	
      function check_field_value()
      {
		

          var to_val = $('#to').val();

          var from_val = $('#from').val();

          var msg_val = $("#card-message").val();

          var check_val = $("#type").prop("checked");
        
          if(to_val == '' && from_val =='' && msg_val =='' && check_val == false )
          {
               $(".f-btn").addClass('finish');
               $(".f-btn").removeClass('finish-btn');

          }
          else if(to_val == '' && from_val =='' && msg_val =='' && check_val == true )
          {
               $(".f-btn").addClass('finish-btn');
               $(".f-btn").removeClass('finish');

          }
        
        
          else if(to_val != '' && from_val !='' && msg_val !='')
          {
                        
            	$(".f-btn").addClass('finish-btn');
               	$(".f-btn").removeClass('finish');

          }
          else
          {
          
          	   $(".f-btn").addClass('finish');
               $(".f-btn").removeClass('finish-btn');

          
          }
       }
  
  
  
  
      $(document).on("click", ".finish-btn", function (){
        
              
        var box_contents = $('.box_content').html();
        
        var card_name = $('.card-name').text();
        
        var to = $('#to').val();
        
        var from = $('#from').val();
        
        var card_message = $('#card-message').val();
        
        var box_price = $('.box_content').attr('data-price');
        
        var product_id = $('#step1').attr('data-prod-id');
       
        
        var box_color = $('.box-color').text();
        
        
              
        $('.app-product-media').each(function(){
           
           var app_alt_img = $(this).attr('data-media-alt');
           
                     
              if(app_alt_img == box_color) {
                
                var app_img_id = $(this).attr('data-media-id');
                
              $('.select-box-img').text(app_img_id);
                
              }
           
         });
        
        var s_img_id =  $('.select-box-img').text();
       
        
        $.ajax({
          url :"https://app.whitelilyshoppe.com/create_product.php",
          type :'POST',
           data: {product_id:product_id,build_box_size:box_color,price:box_price,image_id:s_img_id},
            dataType: "json",   
            success : function (result) {
            //alert(result);
            console.log(result);
			
              $('.new_variant_id').text(result);
             
          },
          error : function (data, errorThrown) {
            
            alert('error');
            
          }
        });
        
        
        setTimeout(function(){
          
           var variant_id = $('.new_variant_id').text();
                                
            addItemToCartTwo(variant_id, 1, to, from, card_name, card_message, box_contents, box_price);
            
        },12000);
            
        setTimeout(function(){
          
              $('.loader-block').hide();
          
        },13000);
        
             
        //addItemToCartTwo(variant_id, 1, card_name, card_message, box_contents, box_price);
        
        
        
        $('.packaging-wrapper').hide();
        $('.custom-gift-collection').hide();      
        $('.card-section').hide();
        $('.shipping-section').show();
        $('html,body').animate({ 'scrollTop': $('#progressbar').offset().top - 200 });
          
        
     });
  
  	  $(document).on("click", ".confirm-btn", function (){
        
        //var variant_id = $('.selected .pick-color').attr('data-id');
              
        var box_contents = $('.box_content').text();
        
        var card_name = $('.card-name').text();
        
        var to = $('#to').val();
        
        var from = $('#from').val();
        
        var card_message = $('#card-message').val();
        
        var box_price = $('.box_content').attr('data-price');
        
         var product_id = $('#step1').attr('data-prod-id');
       
        
        var box_color = $('.box-color').text();
        
        
              
        $('.app-product-media').each(function(){
           
           var app_alt_img = $(this).attr('data-media-alt');
           
                     
              if(app_alt_img == box_color) {
                
                var app_img_id = $(this).attr('data-media-id');
                
              $('.select-box-img').text(app_img_id);
                
              }
           
         });
        
        var s_img_id =  $('.select-box-img').text();
        
        
        $.ajax({
          url :"https://app.whitelilyshoppe.com/create_product.php",
          type :'POST',
           data: {product_id:product_id,build_box_size:box_color,price:box_price,image_id:s_img_id},
            dataType: "json",   
            success : function (result) {
            //alert(result);
            console.log(result);
			
              $('.new_variant_id').text(result);
             
          },
          error : function (data, errorThrown) {
            
            alert('error');
            
          }
        });
        
        
        setTimeout(function(){
          
           var variant_id = $('.new_variant_id').text();
                                
            addItemToCart(variant_id, 1, to, from, card_name, card_message, box_contents, box_price);
            
        },12000);
            
        setTimeout(function(){
          
              $('.loader-block').hide();
          
        },13000);
        
        
        
        
        	
        //addItemToCart(variant_id, 1, card_name, card_message, box_contents, box_price);
        
        $('.packaging-wrapper').hide();
        $('.custom-gift-collection').hide();      
        $('.card-section').hide();
        $('.shipping-section').show();
        $('html,body').animate({ 'scrollTop': $('#progressbar').offset().top - 200 });
        
        
        
        setTimeout(function(){ $('.cart-icon').click() }, 1500);
             


      });
  
  
  
  		function addItemToCart(variant_id, qty, to, from, card_name, card_message, box_contents, box_price) {
            data = {
              "id": variant_id,
              "quantity": qty,
              "properties": {
                "to":to,
                "from":from,
                "card": card_name,
                "card_message": card_message,
                "card_type": 'Blank (Leave on Outside)',
                "box_contents": box_contents,
                "box_price": box_price,
              }
            }
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function() { 
                	document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                    quantity: 1,
                      id: variant_id
                  }
              }));
                
              }
            });
            
  		}
  
  
  		function addItemToCartTwo(variant_id, qty, to, from, card_name, card_message, box_contents, box_price) {
            data = {
              "id": variant_id,
              "quantity": qty,
             "properties": {
                "to":to,
                "from":from,
                "card": card_name,
                "card_message": card_message,
                "box_contents": box_contents,
                "box_price": box_price
              }
            }
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function() { 

               	document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                    quantity: 1,
                      id: variant_id
                  }
              }));
                
              }
            });
           
  		}
  
  
  		


  
    
       $(document).on("click", ".finish", function (){


          $("#confirmationPopup").css('display','block');
         
         $('body').addClass('open-confirmation-popup');


        });


        $(document).on("click", ".confirm-close", function (){

          $("#confirmationPopup").css('display','none');
          $('body').removeClass('open-confirmation-popup');

        });


         $(document).on("click", ".cancel-btn", function (){

          $("#confirmationPopup").css('display','none');
           $('body').removeClass('open-confirmation-popup');

        });



        $(document).mouseup(function (e) {

          $("#confirmationPopup").css('display','none');


       }); 
  
  
   $(document).on("click", ".quick-view-button .add-box ", function (){
     
     tray_slider();
     
  
   });
  function tray_slider(){
    $('.owl-carousel').owlCarousel({
           	loop:false,
      		nav:true,
      		dot:false,
           margin:18,
         responsive:{
          0:{
            items:1,
          },
          601:{
            items:2,
          },
          992:{
            items:3,
          }
        }
        }); 
 
  }
  
  
   // Product filters
  
  function getFilterProducts(url){
    $.ajax({
        type: 'GET',
        url: url,
        data:{},
        success: function(res){
            console.log(res);
        },
        error: function(status){
             alert(status);
        }
    })
}
   
  
  function open_drawer()
  {
  	$('.js-focus-visible').addClass('js-drawer-open');
  
  	$('#CartDrawer').addClass('drawer--is-open');
  	$('#CartDrawer').attr('tab-index','-1');
    $('.site-nav__link site-nav__link--icon cart-icon js-drawer-open-cart').attr('aria-expanded','true');
  }
  
  
  
  $(document).on("click", ".about-btn", function (){
    
   	$(".popup-data").hide();
       
    var elmId = $(this).attr("id");
    
    $("#aboutPopup").find("#"+elmId).show();
    
    $("#aboutPopup").css('display','block');

    $('body').addClass('open-about-popup');


  });


  $(document).on("click", ".about-close", function (){

    $("#aboutPopup").css('display','none');
    $('body').removeClass('open-about-popup');

  });
  
  $(document).on("click", ".about-prod-btn", function () {
    
    var abt_prod_id = $(this).attr('data-id');
    
    $('#quick-view-' + abt_prod_id).trigger('click');
    
    $('#about-qty-'+ abt_prod_id).show();
    
    $(this).hide();
         
      
  });
  
  $(document).on("click", ".about-qty-minus-btn", function () {
    
    var abt_prod_id = $(this).attr('data-id');
    
    $('#qminus-' + abt_prod_id).trigger('click');
         
  });
  
  $(document).on("click", ".about-qty-plus-btn", function () {
    
    var abt_prod_id = $(this).attr('data-id');
    
    $('#qplus-' + abt_prod_id).trigger('click');
         
      
  });
  
   $(document).on("click", ".best-sell-btn", function () {
    
    var best_sell_id = $(this).attr('data-id');
          
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {quantity: 1,
  				id: best_sell_id
        },
        dataType: 'json',
        success: function() { 

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              quantity: 1,
  				id: best_sell_id
            }
          }));

        },
        error: function(error) {alert(error.responseJSON.message);}
      });
            
  });
       
});


$(document).mouseup(function (e) {
   
   var popup = $("#aboutPopup");
     if (!$('.about-btn').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {
        $('body').removeClass('open-about-popup');
        $("#aboutPopup").css('display','none');
     }
 });


function addItemToCartOne(items) {
           
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {items:items},
              dataType: 'json',
              success: function() { 
                     
               document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                    quantity: 1,
                      id: best_sell_id
                  }
              }));
                                        
              },
              error: function(error) {alert(error.responseJSON.message);}
            });
           
  		}
  

 